/**
 * La pastilla con la mascota y «Dashboard»: la salida al panel.
 *
 * Vive aparte porque la usan tres pantallas que no se conocen entre ellas —la
 * de empezar un proyecto y los dos asistentes de creación— y ya se separaron
 * una vez: los asistentes llevaban el logotipo entero a 28px y la de empezar la
 * pastilla a 34, así que la misma barra medía distinto según por dónde se
 * entrara. Escrita tres veces vuelve a pasar.
 *
 * Es la misma pastilla que dentro de un proyecto, sin el desplegable de área:
 * aquí no hay editor ni CMS a los que ir, sólo el camino de vuelta.
 *
 * El rótulo va DENTRO del mismo botón que la mascota: la pastilla entera es una
 * sola cosa, y partirla daría dos paradas de tabulador que llevan al mismo
 * sitio. Dentro de un proyecto sí son dos, porque la segunda despliega el área.
 */
import { IconChevronLeft } from '@tabler/icons-react'
import { VelticaMascot } from '@webbuilder/ui'
import { useI18n } from '../lib/i18n'

export function BrandBackPill({ onClick, disabled = false }: {
  onClick: () => void
  /** Mientras hay algo en marcha que salirse dejaría a medias. */
  disabled?: boolean
}) {
  const { t } = useI18n()
  return (
    <div className="dash-brand-cluster is-fit is-back">
      <button
        className="dash-topbar-home dash-topbar-home--back"
        type="button"
        aria-label={t('nav.backToDashboard')}
        onClick={onClick}
        disabled={disabled}
      >
        <VelticaMascot className="dash-topbar-logo dash-topbar-logo--mark" size={23} />
        {/* El nombre, sólo en el asistente en el celular: ahí la barra no
            lleva más que esto y el «BETA» solo no decía de quién era. */}
        <img className="dash-topbar-wordmark" src="/veltica.svg" alt="véltica" width={54} height={15} decoding="async" />
        <span className="dash-beta-badge">Beta</span>
        {/* «Regresar» y no «Dashboard»: aquí no se está EN el panel sino de
            paso, creando algo. Un rótulo con el nombre del sitio dice dónde
            estás; éste tiene que decir por dónde se sale, y la flecha lo dice
            antes de que se lea la palabra. */}
        <span className="dash-topbar-home-label">
          <IconChevronLeft size={13} aria-hidden="true" />
          {t('nav.back')}
        </span>
      </button>
    </div>
  )
}
